import ChatPage, { getDefaultPageUI } from "components/pages/ChatPage";
import { BCMSStateManagerCRUD } from "bcms-react";

export default function CaptureChatMessageOpen(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showInitialMessage" ], false)
        .submit();

    return <ChatPage ui={ ui } />
}